export default "__VITE_PUBLIC_ASSET__482df569__"